import { Css, StatusBanner, useTestIds } from "@homebound/beam";
import { count } from "src/utils";

type MissingCostsCardProps = { missingLines: number };

export function MissingCostsCard(props: MissingCostsCardProps) {
  const { missingLines } = props;
  const tid = useTestIds({});
  if (missingLines === 0) return null;
  return (
    <div css={Css.mb2.$}>
      <StatusBanner
        {...tid.missingCostsCard}
        type="warning"
        icon="finances"
        title={count(missingLines, "Missing Cost")}
        description="Bid lines missing costs are highlighted below."
      />
    </div>
  );
}
